export enum PrivacyStatus {
    Private = 'Private',
    Public = 'Public',
}